import { useCallback, useMemo } from 'react'
import { UserX } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchErasure, GDPR_STATUS_OPTS, LEGAL_STR as S, type GdprRow } from './legalFlowApi'

/**
 * A19.16 — "Unutilish huquqi" so'rovlari (right to be forgotten, read-only).
 * GDPR erasure so'rovlari — GET /admin/gdpr-requests ustidan (kind=erasure).
 * Faqat kuzatuv (avto-o'chirish yo'q). Backend yo'q/xato → fail-soft.
 */
export function LegalErasureScreen() {
  const columns = useMemo<AdminColumn<GdprRow>[]>(
    () => [
      { key: 'id', header: S.id, type: 'id', width: 70 },
      { key: 'created_at', header: S.created, type: 'date', width: 150 },
      { key: 'subject', header: S.subject, type: 'text', minWidth: 180 },
      { key: 'reason', header: S.reason, type: 'longtext', minWidth: 200 },
      { key: 'due_at', header: S.due, type: 'date', width: 150 },
      { key: 'overdue', header: S.overdue, type: 'bool', width: 110 },
      { key: 'status', header: S.status, type: 'enum', width: 130, options: GDPR_STATUS_OPTS },
    ],
    [],
  )
  const fetcher = useCallback(fetchErasure, [])
  return (
    <>
      <PageHeader title={S.erasureTitle} screenId="A19.16" description={S.erasureDesc} />
      <DataTable<GdprRow>
        screenId="A19.16"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        exportable
        emptyState={{ icon: <UserX size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
